import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-framework-vuedotjs.svg?component
var programming_framework_vuedotjs_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_framework_vuedotjs_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M23.94 3a.5.5 0 0 0-.44-.25h-2.31l-8.55 13.91a.75.75 0 0 1-1.28 0L2.81 2.77H.5A.5.5 0 0 0 .06 3a.54.54 0 0 0 0 .51l11.5 19a.51.51 0 0 0 .86 0l11.5-19a.54.54 0 0 0 .02-.51" }, null, -1), createElementVNode("path", { d: "m12 14.84 7.43-12.07H16a.47.47 0 0 0-.43.25L12 9.26 8.43 3A.47.47 0 0 0 8 2.77H4.57Z" }, null, -1)])]);
}
var programming_framework_vuedotjs_default = { render: render$1 };
//#endregion
export { programming_framework_vuedotjs_default as default, programming_framework_vuedotjs_exports, render$1 as render };

//# sourceMappingURL=programming-framework-vuedotjs.svg.virtual.js.map